export var Globals = {
  // devUrl: 'http://localhost:5000/api/beneficios-oh',
  // url: 'http://localhost:5000/api/beneficios-oh'
  devUrl: 'https://backend.red-salud.com/api/beneficios-oh',
  url: 'https://backend.red-salud.com/api/beneficios-oh',
};
